// extracted by mini-css-extract-plugin
module.exports = {"declined_reason_container":"DeclinedReason_declined_reason_container__267q9","modal_heading":"DeclinedReason_modal_heading__pIPTi","reason":"DeclinedReason_reason__1TKOO"};